/**
 * Smart suggestions pour ajout de nœuds IVR — port 1:1 Next.
 * Retourne les types de nœuds recommandés selon le parent et le handle cliqué.
 */

export interface SmartSuggestion {
  type: string
  priority: number
}

export function getSmartSuggestions(
  parentType: string,
  handleId: string,
): SmartSuggestion[] {
  switch (parentType) {
    case 'start':
      return [
        { type: 'language_select', priority: 1 },
        { type: 'time_check', priority: 2 },
        { type: 'message', priority: 3 },
        { type: 'menu', priority: 4 },
      ]

    case 'time_check':
      if (handleId === 'open') {
        return [
          { type: 'menu', priority: 1 },
          { type: 'language_select', priority: 2 },
          { type: 'route_team', priority: 3 },
        ]
      }
      return [
        { type: 'message', priority: 1 },
        { type: 'voicemail', priority: 2 },
        { type: 'route_ai', priority: 3 },
      ]

    case 'language_select':
      if (handleId === 'timeout' || handleId === 'invalid') {
        return [
          { type: 'message', priority: 1 },
          { type: 'hangup', priority: 2 },
        ]
      }
      return [
        { type: 'menu', priority: 1 },
        { type: 'message', priority: 2 },
        { type: 'route_team', priority: 3 },
      ]

    case 'menu':
      if (handleId === 'timeout' || handleId === 'invalid') {
        return [
          { type: 'message', priority: 1 },
          { type: 'hangup', priority: 2 },
        ]
      }
      return [
        { type: 'route_team', priority: 1 },
        { type: 'route_agent', priority: 2 },
        { type: 'route_ai', priority: 3 },
        { type: 'message', priority: 4 },
        { type: 'voicemail', priority: 5 },
      ]

    case 'message':
      return [
        { type: 'menu', priority: 1 },
        { type: 'route_team', priority: 2 },
        { type: 'voicemail', priority: 3 },
        { type: 'hangup', priority: 4 },
      ]

    case 'caller_condition':
    case 'called_number_condition':
      if (handleId === 'match') {
        return [
          { type: 'route_agent', priority: 1 },
          { type: 'route_team', priority: 2 },
          { type: 'menu', priority: 3 },
        ]
      }
      return [
        { type: 'message', priority: 1 },
        { type: 'menu', priority: 2 },
        { type: 'hangup', priority: 3 },
      ]

    case 'route_team':
    case 'route_agent':
    case 'route_number':
      if (handleId === 'no_answer') {
        return [
          { type: 'voicemail', priority: 1 },
          { type: 'route_team', priority: 2 },
          { type: 'route_ai', priority: 3 },
        ]
      }
      return [{ type: 'hangup', priority: 1 }]

    case 'queue':
      if (handleId === 'timeout') {
        return [
          { type: 'voicemail', priority: 1 },
          { type: 'route_ai', priority: 2 },
          { type: 'message', priority: 3 },
        ]
      }
      return [{ type: 'hangup', priority: 1 }]

    case 'route_ai':
      if (handleId === 'transfer') {
        return [
          { type: 'route_team', priority: 1 },
          { type: 'route_agent', priority: 2 },
        ]
      }
      return [{ type: 'hangup', priority: 1 }]

    case 'voicemail':
      return [{ type: 'hangup', priority: 1 }]

    default:
      return [
        { type: 'message', priority: 1 },
        { type: 'route_team', priority: 2 },
        { type: 'hangup', priority: 3 },
      ]
  }
}
